import { render, staticRenderFns } from "./SandboxLayerPage.vue?vue&type=template&id=20d74631&scoped=true"
import script from "./SandboxLayerPage.vue?vue&type=script&lang=js"
export * from "./SandboxLayerPage.vue?vue&type=script&lang=js"
import style0 from "./SandboxLayerPage.vue?vue&type=style&index=0&id=20d74631&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d74631",
  null
  
)

export default component.exports